<template>
  <ul class="menu-nav">
    <router-link
      to="/dashboard"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-architecture-and-city"></i>
          <span class="menu-text">صفحه نخست</span>
        </a>
      </li>
    </router-link>

    <li
      v-for="(item, index) in menu"
      :key="index"
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-submenu"
      v-can="item.access"
      v-bind:class="{ 'menu-item-open': hasActiveChildren(item.url) }"
    >
      <a
        :href="item.url"
        class="menu-link menu-toggle"
        v-if="item.child.length > 0"
      >
        <i v-if="item.icon != null" :class="`menu-icon ${item.icon}`"></i>
        <i v-else class="menu-icon flaticon2-folder"></i>

        <span class="menu-text">{{ item.name }}</span>
        <i class="menu-arrow"></i>
      </a>

      <div class="menu-submenu" v-if="item.child.length > 0">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">{{ item.name }}</span>
            </span>
          </li>

          <router-link
            v-can="itemchild.access"
            :to="itemchild.url"
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-for="(itemchild, indexchild) in item.child"
            :key="indexchild"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i
                  v-if="itemchild.icon != null"
                  :class="`menu-icon ${itemchild.icon}`"
                ></i>
                <i v-else class="menu-icon flaticon2-paper"></i>
                <span class="menu-text">{{ itemchild.name }}</span
                >‌
              </a>
            </li>
          </router-link>
        </ul>
      </div>

      <router-link
        v-else
        :to="item.url"
        v-slot="{ href, navigate }"
        v-can="item.access"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i
            :class="`menu-icon  ${
              'flaticon2-document' ? 'flaticon2-document' : item.icon
            }`"
          ></i>
          <span class="menu-text">{{ item.name }}</span>
        </a>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: "KTMenu",
  data() {
    return {
      menu: [
        {
          name: "مدیریت مطالب",
          url: "/letter",
          icon: "flaticon2-paper",
          access: ["admin", "article"],
          child: [
            {
              name: "ایجاد مطلب",
              url: "/article/create",
              icon: "flaticon2-paper",
              access: ["admin", "article"],
              child: [],
            },
            {
              name: "مدیریت مطلب",
              url: "/article/mng",
              icon: "flaticon2-paper",
              access: ["admin", "article"],
              child: [],
            },
            {
              name: "موضوعات",
              url: "/article/taxnomy",
              icon: "flaticon2-paper",
              access: ["admin", "article"],
              child: [],
            },
            {
              name: "دیدگاه ها",
              url: "/article/comments",
              icon: "flaticon2-paper",
              access: ["admin", "article", "comments"],
              child: [],
            },
          ],
        },
        {
          name: "ویدئو سنت",
          url: "/video",
          icon: "la la-video",
          access: ["admin", "video"],
          child: [
            {
              name: "افزودن ویدئو",
              url: "/video/create",
              icon: "la la-file-video",
              access: ["admin", "video"],
              child: [],
            },
            {
              name: "مدیریت ویدئو",
              url: "/video/manager",
              icon: "la la-file-video",
              access: ["admin", "video"],
              child: [],
            }
          ],
        },

        {
          name: "مدیریت دسترسی ها",
          url: "/acl",
          icon: "flaticon-lock",
          access: ["admin", "users.access"],
          child: [
            {
              name: " نقش ها",
              url: "/acl/role/add",
              icon: "flaticon2-user",
              access: ["admin", "users.access"],
              child: [],
            },
            {
              name: " دسترسی ها",
              url: "/acl/permsstion/add",
              icon: "flaticon2-user",
              access: ["admin", "users.access"],
              child: [],
            },
            {
              name: " مدیریت کاربران ",
              url: "/acl/users",
              icon: "flaticon2-user",
              access: ["admin", "users.access"],
              child: [],
            },
          ],
        },
        {
          name: "زبان های سایت",
          url: "/lang",
          icon: "flaticon2-paper",
          access: ["admin", "lang"],
          child: [],
        },
        {
          name: "ویرایش صفحه اول سایت",
          url: "/layout/index",
          icon: "flaticon2-paper",
          access: ["admin", "layout"],
          child: [],
        },
      ],
    };
  },

  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
  },
};
</script>
